/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 3/28/2019.
 */

import React from 'react'
import {Button} from "@scuf/common";
import {injectIntl} from "react-intl";

/**
 * The component shows content passed in props. When expandable=true a link in displayed on top of the content
 * to expand and then shows also expandedContent before the standard content. The direction to expand could be
 * configurable in future.
 */
class ExpandableList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: this.props.expanded || false,
        }
    }

    render() {
        const {
            intl,
            expandable,
            content,
            expandedContent,
            expandLinkText,
            className,
            direction,
            ...cleanedProps
        } = this.props

        const expandLinkTextVar = expandLinkText || intl.formatMessage({id: "card.more"})
        const collapsedClass = this.state.expanded ? '' : 'collapsed';

        let expandLink = null
        if (expandable && !this.state.expanded) {
            expandLink = <div className="expand-link">
                <Button type="link"
                        onClick={() => this.setState({expanded: !this.state.expanded})}>
                    {expandLinkTextVar}
                </Button>
            </div>
        }
        // Make it expandable to down
        if (direction === 'down') {
            return (
                <div
                    className={"expandable-list " + className + ' ' + (expandable ? (collapsedClass) : '')} {...cleanedProps}>
                    {content}
                    {
                        this.state.expanded ?
                            expandedContent
                            :
                            null
                    }
                    {expandLink}
                </div>
            )
        }
        // Expandable to up
        return (
            <div
                className={"expandable-list " + className + ' ' + (expandable ? (collapsedClass) : '')} {...cleanedProps}>
                {expandLink}
                {
                    this.state.expanded ?
                        expandedContent
                        :
                        null
                }
                {content}
            </div>
        )
    }
}


ExpandableList.defaultProps = {
    expandable: true,
    content: [],
    expandedContent: [],
    className: '',
}

export default injectIntl(ExpandableList)